function formatPhoneNumber(phoneNumber) {
  // Remova qualquer caractere não numérico do número de telefone
  const cleanedNumber = phoneNumber.replace(/\D/g, '');

  // Verifique se o número é de celular ou telefone fixo com base na quantidade de dígitos
  if (cleanedNumber.length === 11 && cleanedNumber[2] === '9') {
    // É um número de celular
    return cleanedNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if(cleanedNumber.length === 10 && (cleanedNumber[2] === '9' || cleanedNumber[2] === '6' || cleanedNumber[2] === '7' || cleanedNumber[2] === '8' ) ){
        return cleanedNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

  } else if (cleanedNumber.length === 10) {
    // É um número de telefone fixo
    return cleanedNumber.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else {
    // Número de telefone inválido
    return false;
  }
}

export default {
  messages: {
    en: (field, args) => {
      return "Telefone inválido";
    },
    'pt-BR': (field, args) => {
      return "Telefone inválido";
    }
  },
  validate(value) {
    return formatPhoneNumber(value);
  }
};



// WEBPACK FOOTER //
// ./src/validators/generalMask.js